import AutoHeight from 'embla-carousel-auto-height';
import ClassNames from 'embla-carousel-class-names';
import EmblaCarousel from 'embla-carousel';
import addPrevNextBtnsClickHandlers from './arrows';
import setupScrollBar from './scroll-bar';

// Build the Embla Slider
const buildSlider = (selector, emblaOptions = {}) => {
  const emblaNodes = document.querySelectorAll(selector);

  if (!emblaNodes) {
    return;
  }

  let emblaApi;

  emblaNodes.forEach((emblaNode) => {
    const viewportNode = emblaNode.querySelector(`${selector}__viewport`);
    const prevBtn = emblaNode.querySelector(`${selector}__button--prev`);
    const nextBtn = emblaNode.querySelector(`${selector}__button--next`);
    const scrollNode = emblaNode.querySelector(`${selector}__scroll-bar`);
    const plugins = [];

    // @todo Seems like now most of the sliders should not use AutoHeight plugin,
    // Check where is needed to auto calc the height.
    if (!emblaNode.classList.contains('slider--no-auto-height')) {
      plugins.push(AutoHeight());
    }

    // Helper classes to determine states of slider and slides,
    // currently used for knowing draggable state and if slider is in the viewport.
    if (emblaNode.classList.contains('slider--visible-slides')) {
      plugins.push(ClassNames());
    }

    emblaApi = EmblaCarousel(viewportNode, emblaOptions, plugins);

    if (prevBtn && nextBtn) {
      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtn,
        nextBtn,
      );
      emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
    }

    if (scrollNode) {
      const { applyProgress, removeProgress, setScrollbarSize } =
        setupScrollBar(emblaApi, scrollNode);

      emblaApi
        .on('init', applyProgress)
        .on('init', setScrollbarSize)
        .on('reInit', applyProgress)
        .on('reInit', setScrollbarSize)
        .on('scroll', applyProgress)
        .on('destroy', removeProgress);
    }

    if (emblaNode.classList.contains('slider--inactive')) {
      emblaApi.reInit({ active: false, watchDrag: false });
    }
  });

  // if you need to save it to variable
  return emblaApi;
};

export default buildSlider;
